import React from 'react'
import { Image, Segment, Header } from 'semantic-ui-react'

const BodyRebalanceGsrMetric = (props) => (
    <Segment>
        <Header as='h3'>
            Electrodermal Activity change after an emotional event
        </Header>
        <Image src={`data:image/jpeg;base64,${props.body_rebalance_gsr_metric}`} alt={`${"gsr_body_rebalance.png"}`} centered/>
    </Segment>
)

export default BodyRebalanceGsrMetric



// WEBPACK FOOTER //
// ./src/components/participant-feel-data-reports/metrics/body-rebalance-gsr.js